(function () {
function kmLanguageCartUrl(destination){
  var url=new URL(destination||'/cart',window.location.origin);
  if(url.origin!==window.location.origin)return url.href;
  var prefix=window.location.pathname.split('/')[1]||'';
  var language=(document.documentElement.lang||'').toLowerCase().split('-')[0];
  if(/^[a-z]{2,3}(?:-[a-z0-9]{2,8})*$/i.test(prefix)&&prefix.toLowerCase().split('-')[0]===language){
    var cartPath=url.pathname.replace(/^\/[a-z]{2,3}(?:-[a-z0-9]{2,8})*(?=\/cart(?:\/|$))/i,'');
    if(/^\/cart(?:\/|$)/.test(cartPath))url.pathname='/'+prefix+cartPath;
  }
  return url.pathname+url.search+url.hash;
}

  'use strict';
  if (window.kmShopPageLoaded) return;
  window.kmShopPageLoaded = true;
  function setup(root) {
    if (root.dataset.kshReady) return;
    root.dataset.kshReady = 'true';
    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-ksh-filter]');
      if (!button || !root.contains(button)) return;
      var filter = button.dataset.kshFilter;
      root.querySelectorAll('[data-ksh-filter]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === button)); });
      var visible = 0;
      root.querySelectorAll('[data-ksh-family]').forEach(function (card) {
        card.hidden = filter !== 'all' && card.dataset.kshFamily !== filter;
        if (!card.hidden) visible++;
      });
      var catalog = root.querySelector('[data-ksh-catalog]');
      if (catalog) catalog.dataset.filtered = String(filter !== 'all');
      var count = root.querySelector('[data-ksh-count]');
      if (count) count.textContent = String(visible);
      var empty = root.querySelector('[data-ksh-no-matches]');
      if (empty) empty.hidden = visible > 0;
    });
    root.addEventListener('submit', async function (event) {
      var form = event.target.closest('[data-ksh-add]');
      if (!form || !root.contains(form)) return;
      event.preventDefault();
      var button = form.querySelector('button[type="submit"]');
      if (!button || button.disabled) return;
      var status = form.closest('.ksh__product').querySelector('.ksh__cart-status');
      status.replaceChildren();
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = root.dataset.adding;
      try {
        var response = await fetch(root.dataset.addUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
        var result = await response.json();
        if (!response.ok || result.status >= 400) {
          throw new Error(typeof result.description === 'string' ? result.description : root.dataset.error);
        }
        button.textContent = root.dataset.added;
        status.appendChild(document.createTextNode(root.dataset.added));
        var cartLink = document.createElement('a');
        cartLink.href = kmLanguageCartUrl(root.dataset.cartUrl);
        cartLink.textContent = root.dataset.cartLabel;
        status.appendChild(cartLink);
        if (root.dataset.afterAdd === 'cart') {
          window.location.assign(kmLanguageCartUrl(root.dataset.cartUrl));
          return;
        }
      } catch (error) {
        status.textContent = error.message || root.dataset.error;
      }
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = button.dataset.originalLabel;
    });
  }
  function init(scope) {
    if (scope.matches && scope.matches('[data-ksh-shop]')) setup(scope);
    scope.querySelectorAll('[data-ksh-shop]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var card = event.target.closest('.ksh__product');
    var root = event.target.closest('[data-ksh-shop]');
    if (card && root && card.hidden) {
      var all = root.querySelector('[data-ksh-filter="all"]');
      if (all) all.click();
    }
  });
})();
